class ProductParamsTable extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    const handle = this.dataset.handle;
    if (!handle || typeof jsonData === 'undefined') return;

    const dataKey = this.findDataKey(handle);
    if (!dataKey || !jsonData[dataKey] || !jsonData[dataKey].length) return;

    const headers = jsonData.table_header;
    const rows = jsonData[dataKey];
    const grouped = this.groupByMaterial(rows);

    this.innerHTML = `
      <div class="params-table__wrapper">
        <h3 class="params-table__title">Model Parameters</h3>
        <div class="params-table__scroll">
          <table class="params-table">
            <thead>
              <tr>
                ${headers.map((h) => `<th>${h}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${this.renderGroupedRows(grouped)}
            </tbody>
          </table>
        </div>
      </div>
    `;
  }

  findDataKey(handle) {
    const normalized = handle.replace(/[-_]/g, '').toLowerCase();
    for (const key in jsonData) {
      if (key === 'table_header') continue;
      if (key.toLowerCase() === normalized) return key;
    }
    // Try removing common prefixes
    const withoutPrefix = normalized.replace(/^atomstack/, '');
    for (const key in jsonData) {
      if (key === 'table_header') continue;
      if (key.toLowerCase() === withoutPrefix) return key;
    }
    // Partial match: check if handle contains the key or vice versa
    for (const key in jsonData) {
      if (key === 'table_header') continue;
      const keyNorm = key.toLowerCase();
      if (normalized.includes(keyNorm) || keyNorm.includes(normalized)) return key;
    }
    return null;
  }

  groupByMaterial(rows) {
    const groups = [];
    let current = null;
    for (const row of rows) {
      if (!current || current.name !== row.name) {
        current = { name: row.name, rows: [row] };
        groups.push(current);
      } else {
        current.rows.push(row);
      }
    }
    return groups;
  }

  renderGroupedRows(groups) {
    let html = '';
    for (const group of groups) {
      group.rows.forEach((row, i) => {
        html += '<tr>';
        if (i === 0) {
          html += `<td class="params-table__material" rowspan="${group.rows.length}">${group.name}</td>`;
        }
        html += `<td>${row.software}</td>`;
        html += `<td>${row.thickness}</td>`;
        html += `<td>${row.quality}</td>`;
        html += `<td>${row.processing}</td>`;
        html += `<td>${row.speed}</td>`;
        html += `<td>${row.max}</td>`;
        html += `<td>${row.mode}</td>`;
        html += `<td>${row.number}</td>`;
        html += '</tr>';
      });
    }
    return html;
  }
}

if (!customElements.get('product-params-table')) {
  customElements.define('product-params-table', ProductParamsTable);
}
